import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2, ExternalLink } from 'lucide-react';
import { openCalendlyPopup } from '../utils/calendly';
export function PersonalHero() {
  return <section className="relative w-full py-20 lg:py-32 overflow-hidden" data-id="element-164" data-mp="3lp96a2l0kvs7">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-165" data-mp="3grz4rokcoto0">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-[#FF5722]/10 rounded-full blur-[120px]" data-id="element-166" data-mp="i9tuavt2sc4f" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-[#3B82F6]/5 rounded-full blur-[120px]" data-id="element-167" data-mp="dbinkty2uhqf" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-168" data-mp="8d7cygzyk375">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-169" data-mp="48r88j22z1ti">
          {/* Text Content */}
          <div className="space-y-8" data-id="element-170" data-mp="2t2oe4zwpsfnl">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#1E293B] border border-[#334155]" data-id="element-171" data-mp="2p002ylkj2wng">
              <span className="w-2 h-2 rounded-full bg-[#FF5722] mr-2 animate-pulse" data-id="element-172" data-mp="3hi1chdeph0cw"></span>
              <span className="text-sm font-medium text-[#94A3B8]" data-id="element-173" data-mp="3mi5xngqk6j9g">
                Justus Kraft • CRM Experte
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-174" data-mp="38hlf8lok2pgh">
              Vom IT-Entwickler zum{' '}
              <span className="text-[#FF5722]" data-id="element-175" data-mp="2ysbn55tpp6sd">Vertriebs-Automatisierer</span>
            </h1>

            <p className="text-lg text-[#94A3B8] max-w-xl leading-relaxed" data-id="element-176" data-mp="33is2ivh3f2hd">
              Mit 16 Jahren mein erstes Gewerbe gegründet. Heute, mit 23 Jahren,
              helfe ich Unternehmen, ihren Vertrieb durch intelligente
              CRM-Systeme zu verdoppeln.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-177" data-mp="2tqm7tdzgi6yh">
              <Button size="lg" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-179" data-mp="2kssembwzntfj" />} onClick={openCalendlyPopup} data-id="element-178" data-mp="2fuile6utr2wk">
                Kostenlose Demo buchen
              </Button>
              <Button variant="outline" size="lg" rightIcon={<ExternalLink className="w-5 h-5" data-id="element-181" data-mp="lj92c08dtzvy" />} onClick={() => window.open('https://crm-kraft.de/', '_blank', 'noopener,noreferrer')} data-id="element-180" data-mp="qdwrm1b7mybl">
                Mehr über CRM Kraft
              </Button>
            </div>

            <div className="pt-8 flex items-center gap-6 text-sm text-[#94A3B8]" data-id="element-182" data-mp="14d4tj1yrckjh">
              <div className="flex items-center gap-2" data-id="element-183" data-mp="109gjmcmnlcv2">
                <CheckCircle2 className="w-4 h-4 text-[#FF5722]" data-id="element-184" data-mp="10c2sqgp700fe" />
                <span data-id="element-185" data-mp="van4kfrpxdss">110+ Zufriedene Kunden</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-186" data-mp="3l0qsme5refl3">
                <CheckCircle2 className="w-4 h-4 text-[#FF5722]" data-id="element-187" data-mp="3ky4a5jhbyfo3" />
                <span data-id="element-188" data-mp="3g0kt6bt8zosg">DSGVO-konform</span>
              </div>
            </div>
          </div>

          {/* Image/Visual Placeholder */}
          <div className="relative md:h-[450px] lg:h-[600px] flex items-center justify-center" data-id="element-189" data-mp="1vhihxidd6j58">
            <div className="relative w-full max-w-sm md:max-w-xs lg:max-w-md aspect-[4/5] rounded-2xl overflow-hidden border border-[#1E293B] shadow-2xl" data-id="element-190" data-mp="20g23viryjuxl">
              {/* Professional Photo - Optimized for performance */}
              <img src="https://cdn.magicpatterns.com/uploads/jWaCxaLsc32b7Nk2LkzDn3/62dfd10966fa026013ebcbcf_565aa1ce-min-p-1600_(3).jpg" alt="Justus Kraft - CRM Experte" className="w-full h-full object-cover" loading="eager" fetchPriority="high" decoding="async" width="800" height="1000" data-id="element-191" data-mp="2eacn5kl6qww9" />

              {/* Overlay gradient for better text contrast on floating card */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E27]/60 via-transparent to-transparent" data-id="element-192" data-mp="xutc0xfjjme3"></div>

              {/* Floating Card */}
              <div className="absolute bottom-8 right-[-20px] bg-[#141B3A] p-4 rounded-xl border border-[#334155] shadow-xl max-w-[200px] animate-bounce duration-[3000ms]" data-id="element-193" data-mp="2n983av7x42v">
                <div className="flex items-center gap-3 mb-2" data-id="element-194" data-mp="cit03m6nvimc">
                  <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center text-green-500" data-id="element-195" data-mp="7k7zvmresyxw">
                    <ArrowRight className="w-4 h-4 -rotate-45" data-id="element-196" data-mp="3g0ueke6mvrlh" />
                  </div>
                  <div data-id="element-197" data-mp="3b29goleutk07">
                    <p className="text-xs text-[#94A3B8]" data-id="element-198" data-mp="3b317zk1f4vko">Umsatzsteigerung</p>
                    <p className="text-sm font-bold text-white" data-id="element-199" data-mp="3pqw1v3r5x5zc">
                      + €7M generiert
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}